(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mineralissima-footer-editorial"]) return;
  try {
    
function setupMineralissimaFooter(){
  document.querySelectorAll('[data-mm-footer]').forEach(function(footer){
    if(footer.dataset.ready)return;
    footer.dataset.ready='true';
    var media=window.matchMedia('(max-width:700px)');
    var update=function(){footer.querySelectorAll('details').forEach(function(group){group.open=!media.matches;});};
    update();media.addEventListener('change',update);
    var top=footer.querySelector('.mm-editorial-footer__top');
    if(top)top.addEventListener('click',function(){window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupMineralissimaFooter);}else{setupMineralissimaFooter();}
document.addEventListener('shopify:section:load',setupMineralissimaFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mineralissima-home-testers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pending = false;
  function alignCards() {
    pending = false;
    var pairs = [
      ['.mm-home-shade__kicker', '.mm-home-testers__kicker'],
      ['.mm-home-shade h2', '.mm-home-testers h2'],
      ['.mm-home-shade__text', '.mm-home-testers__text']
    ];
    pairs.forEach(function (selectors) {
      var left = document.querySelector(selectors[0]);
      var right = document.querySelector(selectors[1]);
      if (!left || !right) return;
      left.style.minHeight = '';
      right.style.minHeight = '';
      if (window.matchMedia('(min-width: 701px)').matches) {
        var height = Math.ceil(Math.max(left.getBoundingClientRect().height, right.getBoundingClientRect().height));
        left.style.minHeight = height + 'px';
        right.style.minHeight = height + 'px';
      }
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(alignCards);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
})();

  } catch(e) { console.error(e); }
})();
})();
